<template>
  <header class="header wrapper">
    <h1>
      <router-link :to="{name: 'Index'}" class="header__logo framed" title="Back to home">Noé Falque</router-link>
    </h1>
    <nav class="header__nav">
      <router-link v-if="$route.path == '/about'" :to="{name: 'Index'}" class="btn btn--small">projects</router-link>
      <router-link v-if="$route.path != '/about'" :to="{name: 'About'}" class="btn btn--small">about</router-link>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'HeaderMenu',
  data () {
    return {
      aaa: 'bbb'
    }
  }
}
</script>

<style lang="scss" scoped>

  .header {
    position: absolute;
    z-index: 5;
    left: 0;
    right: 0;
    top: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 36px;
    font-size: 1.2em;
    // mix-blend-mode: color-burn;
    animation: .5s appearHeader both;

    &__logo {
    //   border-bottom: none;
      text-transform: lowercase;
    }

  }

  @keyframes appearHeader {
    from { opacity: 0; transform: translateY(-40px) rotateX(10deg); }
    to   { opacity: 1; transform: translateY(0) rotateX(0); }
  }

</style>



// WEBPACK FOOTER //
// src/components/_HeaderMenu.vue